import script from "./ProfileInfoLinks.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileInfoLinks.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileInfoLinks.vue?vue&type=style&index=0&id=58b64ee4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58b64ee4"]])

export default __exports__